// Default modules (sections) for every public page. The database (page_modules)
// stores admin overrides; anything missing there falls back to these defaults.
export interface ModuleDef { key: string; label: string }
export interface ModulePageDef { slug: string; label: string; path: string; modules: ModuleDef[] }

export const MODULE_PAGES: ModulePageDef[] = [
  {
    slug: "home", label: "Home", path: "/",
    modules: [
      { key: "hero", label: "Hero" },
      { key: "video", label: "Video" },
      { key: "value", label: "Value Proposition" },
      { key: "pricing", label: "Pricing" },
      { key: "how-it-works", label: "How It Works" },
      { key: "authority", label: "Authority" },
      { key: "seo-block", label: "SEO Block" },
      { key: "trusted-partners", label: "Trusted Partners" },
      { key: "target-clients", label: "Target Clients" },
      { key: "featured-work", label: "Featured Work" },
      { key: "testimonials", label: "Testimonials" },
      { key: "lead-capture", label: "Lead Capture" },
      { key: "faq", label: "FAQ" },
      { key: "final-cta", label: "Final Call to Action" },
    ],
  },
  {
    slug: "about", label: "About Us", path: "/about-us",
    modules: [
      { key: "hero", label: "Page Header" },
      { key: "video-mission", label: "Video, Mission & Vision" },
      { key: "differentiators", label: "Differentiators" },
      { key: "stats", label: "Stats" },
      { key: "story", label: "Our Story" },
    ],
  },
  {
    slug: "industries", label: "Industries", path: "/industries",
    modules: [
      { key: "hero", label: "Page Header" },
      { key: "cards", label: "Industry Cards" },
      { key: "cta", label: "Call to Action" },
    ],
  },
  {
    slug: "consultation", label: "Consultation", path: "/consultation",
    modules: [
      { key: "header", label: "Header & Form" },
      { key: "benefits", label: "Benefits" },
      { key: "badges", label: "Trust Badges" },
    ],
  },
  {
    slug: "contact", label: "Contact", path: "/contact",
    modules: [
      { key: "form", label: "Contact Form & Info" },
      { key: "map", label: "Google Map" },
    ],
  },
  {
    slug: "our-work", label: "Our Work", path: "/our-work",
    modules: [
      { key: "hero", label: "Page Header" },
      { key: "grid", label: "Project Grid" },
      { key: "cta", label: "Call to Action" },
    ],
  },
  {
    slug: "careers", label: "Careers", path: "/careers",
    modules: [
      { key: "hero", label: "Page Header" },
      { key: "jobs", label: "Job Board" },
      { key: "cta", label: "Closing Call to Action" },
    ],
  },
  {
    slug: "service", label: "Service Pages (all)", path: "/services/it-support",
    modules: [
      { key: "hero", label: "Page Header" },
      { key: "what-is", label: "What Is" },
      { key: "features", label: "Why Smartly & Key Features" },
      { key: "faq", label: "FAQ" },
      { key: "related", label: "Related Services" },
    ],
  },
];

export const getModulePage = (slug: string) => MODULE_PAGES.find((p) => p.slug === slug);
